import { useState } from 'react'
import ReactTooltip from 'react-tooltip'
import EditDateReservationModal from 'pages/Modals/EditDateReservationModal'
import EditExceptionalDateModal from 'pages/Modals/EditExceptionalDateModal'
import Logo from 'icons/logo-cutilei-white.png'
import { FaLock, FaMobileAlt, FaEdit } from 'react-icons/fa'
import { Container, Image, EditIcon, Label } from './styles'

export default function DateReservation ({
  data: reservation,
  place = 'right',
  tooltipRadius = '10',
  onEdit: handleEdit = () => {},
}) {
  const [showEditReservationModal, setShowEditReservationModal] = useState (false)
  const isExceptionalDate = !!reservation.start_time

  const tooltipMessage = isExceptionalDate
    ? `Este dia está configurado como data excepcional para atender agendamentos ${
        reservation.type === 'online' ? 'online' : 'Cutilei'
      }`
    : `Este dia está reservado para não atender agendamentos ${
        reservation.type === 'online' ? 'online' : 'Cutilei'
      }`

  const toggleEditReservationModal = () => setShowEditReservationModal (!showEditReservationModal)

  return (
    <>
      <Container
        onClick={toggleEditReservationModal}
        data-for={reservation.id}
        data-tip
      >
        {!isExceptionalDate && <FaLock color='#FFFFFF' size={14}/>}
        {reservation.type === 'online' ? (
          <FaMobileAlt color='#FFFFFF' size={14}/>
        ) : (
          <Image src={Logo}/>
        )}
        <Label>
          {reservation.description}
        </Label>
        <EditIcon>
          <FaEdit color='#FFC100' size={16}/>
        </EditIcon>
        <ReactTooltip
          id={reservation.id}
          effect='solid'
          place={place}
          backgroundColor='#252525'
          tooltipRadius={tooltipRadius}
        >
          <Label style={{width: 300}}>
            {tooltipMessage}
          </Label>
        </ReactTooltip>
      </Container>
      {isExceptionalDate ? (
        <EditExceptionalDateModal
          visible={showEditReservationModal}
          data={reservation}
          onConfirm={handleEdit}
          onClose={toggleEditReservationModal}
        />
      ) : (
        <EditDateReservationModal
          visible={showEditReservationModal}
          data={reservation}
          onConfirm={handleEdit}
          onClose={toggleEditReservationModal}
        />
      )}
    </>
  )
}
